import React from "react";
import { scoreLabel, scoreTier } from "@/lib/mockData";

const COLORS = {
  genuine: "#22C55E",
  inconclusive: "#F59E0B",
  ai: "#EF4444",
};

export default function ConfidenceRing({ score, size = 168, stroke = 12, showLabel = true }) {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const tier = scoreTier(score);
  const color = COLORS[tier];
  const offset = circumference - (Math.max(0, Math.min(100, score)) / 100) * circumference;

  return (
    <div
      className="relative flex items-center justify-center"
      data-testid="confidence-ring"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="-rotate-90" aria-hidden="true">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#1A1D24"
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 800ms cubic-bezier(.22,1,.36,1)" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center justify-center">
        <div
          className="font-bold tracking-tight"
          style={{ color, fontSize: size * 0.32, lineHeight: 1 }}
          data-testid="confidence-score-value"
        >
          {score}
        </div>
        {showLabel && (
          <div
            className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1"
            data-testid="confidence-score-label"
          >
            {scoreLabel(score)}
          </div>
        )}
      </div>
    </div>
  );
}
